module.exports = __webpack_public_path__ + "static/media/qr.a5065cd8.png";